import styles from '../../home-page/HomePage.module.scss';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import Label from '../../../constants/Label';
import { beneficiaryActions, ratesActions } from '../../../stores/_actions';
import { Pagination } from 'semantic-ui-react';
import { NoRecord } from '../norecord/norecord';
import { ListItems } from './ListItems';

function Beneficary() {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const dispatch = useDispatch();
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: profile?.CustomerCode,
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
    FileType: null,
    Langcode: null,
  };

  useEffect(() => {
    dispatch(beneficiaryActions.beneficiaryClient(payload));
    dispatch(ratesActions.clearRatesData());
  }, []);

  const [setList, setListData] = useState();
  let customerListData;
  let status;
  useSelector((state) => {
    customerListData = state.beneficary?.data;
    status = state.beneficary?.beneficiaryList;
    setTimeout(() => {
      setListData((setList) => (setList = customerListData));
    }, 50);
  });

  const [pager, setPage] = useState({
    page: 1,
    itemsPerPage: 1,
  });
  const setPageNum = (event, { activePage }) => {
    setPage({ page: activePage, customerListData });
  };
  const itemsPerPage = 1;
  const { page } = pager;
  const totalPages = Math.ceil(customerListData && customerListData.length / itemsPerPage);
  const items = customerListData && customerListData.slice((page - 1) * itemsPerPage, (page - 1) * itemsPerPage + itemsPerPage);

  return (
    <div className={styles.rightBottom}>
      <h2>
        {Label.Addbeneficiary.heading2} <Link to="/beneficiaries">view all</Link>
      </h2>
      {customerListData ? <ListItems list={items} styles={styles} /> : <NoRecord status={status} />}
      {customerListData ? (
        <div className={styles.pageCount}>
          <div className={styles.pageCountcont}>
            <span>{page}</span> / <span>{totalPages}</span>
          </div>
          <div className={styles.carousal}>
            <Pagination
              boundaryRange={0}
              defaultActivePage={page}
              ellipsisItem={null}
              firstItem={null}
              lastItem={null}
              siblingRange={null}
              totalPages={totalPages}
              onPageChange={setPageNum}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}

export { Beneficary };
